import { LinearProgress } from "@mui/material";
import { displayDocumentStatus } from "Backend";
import { P } from "theme/typography";
import { DocumentStatus } from "generated/graphql";
import { type DocumentIntakeAugmented } from "redux/slices/case";

interface IntakeStatusProps {
  intake: DocumentIntakeAugmented;
}

const IntakeStatus = ({ intake }: IntakeStatusProps) => {
  const { segmentMetrics } = intake;
  const hasSegments = segmentMetrics.segmentNumber !== 0;
  const completePercentage = hasSegments
    ? (segmentMetrics.segmentsCompleted / segmentMetrics.segmentNumber) * 100
    : undefined;
  const isComplete = intake.status !== DocumentStatus.Processing || completePercentage === 100;
  const showPercentage = completePercentage !== undefined && !isComplete;

  return (
    <>
      <P variant="body4" sx={{ display: "block" }}>
        {displayDocumentStatus(intake.status)}
      </P>
      {showPercentage && <LinearProgress variant="determinate" color="primary" value={completePercentage} />}
    </>
  );
};

export default IntakeStatus;
